import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API_URL, setSession, clearSession } from '../auth/authMode';

function returnToDesk() {
    const back = localStorage.getItem('desk-return') || '';
    localStorage.removeItem('desk-return');
    try {
        const url = new URL(back);
        const hostOk = url.hostname === '127.0.0.1' || url.hostname === 'localhost';
        const portOk = url.port === '8010' || url.port === '5174';
        if (url.protocol === 'http:' && hostOk && portOk) {
            window.location.replace(url.toString());
            return true;
        }
    } catch {
        /* stay in HR */
    }
    return false;
}

const MicrosoftCallback = () => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const [error, setError] = useState('');

    useEffect(() => {
        const code = params.get('code');
        if (!code) {
            setError('Missing sign-in code');
            return;
        }
        let cancelled = false;
        (async () => {
            try {
                const res = await fetch(`${API_URL}/auth/sso/microsoft/exchange`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ code }),
                });
                const data = await res.json().catch(() => ({}));
                if (!res.ok) throw new Error(data.error || 'Microsoft sign-in failed');
                if (cancelled) return;
                setSession(data.token, data.user);
                if (returnToDesk()) return;
                navigate('/dashboard', { replace: true });
            } catch (err) {
                clearSession();
                if (!cancelled) setError(err.message || 'Microsoft sign-in failed');
            }
        })();
        return () => { cancelled = true; };
    }, [params, navigate]);

    return (
        <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center' }}>
            <h1>{error || 'Signing in…'}</h1>
        </div>
    );
};

export default MicrosoftCallback;
